<template>
  <div class="bill">
      <main class="content">
          <el-card>
              <el-form :inline="true" :model="searchForm" :disabled="loading" size="mini">
                  <el-form-item label="账单编号" label-width="70px">
                      <el-input v-model="searchForm.billId" placeholder="账单编号" size="mini" clearable style="width: 150px"></el-input>
                  </el-form-item>
                  <el-form-item label="客户订单编号" label-width="100px">
                      <el-input v-model="searchForm.customerOrderId" placeholder="客户订单编号" size="mini" clearable style="width: 150px"></el-input>
                  </el-form-item>
                  <el-form-item label="出账日期">
                      <el-date-picker size="mini" v-model="searchForm.timeDate" type="daterange" range-separator="至"
                                      start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                                      :picker-options="pickerOptions" clearable>
                      </el-date-picker>
                  </el-form-item>
                  <el-form-item label="状态" label-width="70px">
                      <el-select v-model="searchForm.billStatus" placeholder="状态" size="mini" clearable style="width: 150px">
                          <el-option label="全部" value=""></el-option>
                          <el-option label="对账申请中" value="1"></el-option>
                          <el-option label="对账完成" value="2"></el-option>
                          <el-option label="对账差异" value="3"></el-option>
                          <el-option label="差异确认中" value="4"></el-option>
                          <el-option label="对账驳回" value="5"></el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item label="是否开票" label-width="70px">
                      <el-select v-model="searchForm.invoiced" placeholder="是否开票" size="mini" clearable style="width: 150px">
                          <el-option label="全部" value=""></el-option>
                          <el-option label="已开票" value="true"></el-option>
                          <el-option label="未开票" value="false"></el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item>
                      <el-button type="primary" @click="doSearch" size="mini">查询</el-button>
                  </el-form-item>
              </el-form>
              <div ref="tablePosition"></div>
              <el-table
                  stripe
                  :data="tableData"
                  v-loading="loading"
                  style="width: 100%"
                  :height="tableConfig.height"
                  size="mini"
                  @selection-change="handleSelectionChange"
              >
                  <el-table-column type="selection" width="55" fixed/>
                  <el-table-column prop="billId" label="账单编号" width="200" />
                  <el-table-column prop="billDate" label="出账日期" min-width="200"/>
                  <el-table-column prop="finalPayDate" label="最后还款日" width="200"/>
                  <el-table-column prop="currentOrderNum" label="订单总数" width="80"/>
                  <el-table-column prop="totalBatchAmount" label="账单总金额" width="80"/>
                  <el-table-column prop="status" label="状态" width="80">
                      <template slot-scope="scope">
                          <el-tag v-if="scope.row.status == 1" size="mini">申请中</el-tag>
                          <el-tag type="success" v-if="scope.row.status == 2" size="mini">已完成</el-tag>
                          <el-tag type="warning" v-if="scope.row.status == 3" size="mini">对账差异</el-tag>
                          <el-tag v-if="scope.row.status == 4" size="mini">异常确认中</el-tag>
                          <el-tag type="warning" v-if="scope.row.status == 5" size="mini">驳回</el-tag>
                      </template>
                  </el-table-column>
                  <el-table-column prop="invoiced" label="是否开票" width="90">
                      <template slot-scope="scope">
                          <el-tag type="success" v-if="scope.row.invoiced" size="mini">已开票</el-tag>
                          <el-tag type="info" v-else size="mini">未开票</el-tag>
                      </template>
                  </el-table-column>
                  <el-table-column label="操作" width="100" align="right" fixed="right">
                      <template slot-scope="scope">
                          <el-button type="text" size="mini" @click="handleToOrder(scope.row)">订单</el-button>
                      </template>
                  </el-table-column>
              </el-table>
            <div style="text-align: center;padding-top: 20px">
                <el-pagination background layout="sizes, prev, pager, next" v-if="total>0" :total="total"
                                :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :current-page="currentPage" @size-change="handleSizeChange"
                                @current-change="onPageChange" @prev-click="onPageChange" @next-click="onPageChange">
                </el-pagination>
            </div>
          </el-card>
      </main>
  </div>
</template>

<script>
import RightToolBar from "@/components/RightToolBar.vue";

const HEIGHT_OFFSET = 118;

export default {
    name: "Bill",
    components: {RightToolBar},
    data() {
        return {
            searchForm: {
                billId: "",
                customerOrderId: "",
                billStatus: "",
                invoiced: "",
                timeDate: "",
            },
            tableConfig: {
                height: 0,
            },
            searchFormStash: {},
            selectData: [],
            loading: false,
            total: 0,
            pageSize: 10,
            pageSizes: [10, 20, 50, 100],
            currentPage: 1,
            tableData: [],
        }
    },
    created() {
        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
        this.onSearch();
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);
    },
    methods: {
        onSearch() {
            this.selectData = [];
            let cond = { ...this.searchForm };
            if (!this.searchForm.billStatus) {
                cond['billStatus'] = undefined;
            }
            if (this.searchForm.invoiced === 'true') {
                cond.invoiced = true;
            } else if (this.searchForm.invoiced === 'false') {
                cond.invoiced = false;
            } else {
                cond.invoiced = undefined;
            }
            if (this.searchForm.timeDate != "" && this.searchForm.timeDate != null) {
                cond["startTime"] = this.searchForm.timeDate[0];
                cond["endTime"] = this.searchForm.timeDate[1];
            }
            this.searchFormStash = {...cond};
            this.loading = true;
            let _this = this
            this.$axios.post("/admin/jcy/settlement/billList", {
                cond: cond,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function () {
                this.loading = false;
            });
        },
        doSearch() {
            this.currentPage=1;
            this.onSearch();
        },
        pickerOptions: {
            disabledDate(time) {
                return time.getTime() > Date.now();
            },
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        handleToOrder(row) {
            this.$router.push({
                name: "jcyorder", query: {billId:row.billId}, params:{title:"订单列表"}
            });

        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        },
    }
}
</script>

<style scoped>

</style>
